

<template>
  <vx-card class="limited-max-width" id="eighth-step">
    
    <div >
      <header-step-process-component
          v-bind:step="step">
      </header-step-process-component>

      <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Beneficiarios, fecha de inicio y datos de facturación.</span> 
      <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;"> Indícanos cuando quieres que entre en vigor el seguro, los beneficiarios 
          y los datos bancarios por donde giraremos los recibos.</span>
    
      <forms-repository
          v-bind:formFilter="formFilter"
          v-bind:code="code"
          v-bind:previus="previus"
          v-bind:next="next"

          @beneficiariesInfo="beneficiariesForm">
      </forms-repository>
    </div>
  </vx-card>

</template>
<script>
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue'
import FormsRepository from '../forms/e-prevision-forms/forms-repository.vue'
/* eslint-disable */ 
export default {
  components: { VxCard, HeaderStepProcessComponent, FormsRepository },
   data() {
      return {
        step: 8,
        code: this.$route.params.code,
        formFilter: "beneficiariesForm",
        next: "signaturit",
        previus: "commercial-offer/seventh",
        dataStored: null,

        beneficiariesData: "beneficiaries",
        initialData: null,
        insuredData: null,
        policyholder: null,
        // packCommercialOfferDetail: null,
        commercialOffer: null,
        beneficiariesData: null,
        packCommercialOfferCapital: null,
        healthQuestionnaire: null,
        publicResponsabilityForm: null,
        packSelected: null,
        offerCalculated: null,
        initDataConverted: "",
        todaysDate:"",
        todaysDay:"",
        todaysMonth:"",
        todaysYear:"",
        formToFill: {
            fecha_completa:"",
            fecha_efecto_global: "",
            nombre_tomador: "",
            primer_apellido_tomador: "",
            segundo_apellido_tomador: "",
            nif_tomador: "",
            domicilio_tomador: "",
            domicilio_numero_tomador: "",
            domicilio_piso_tomador: "",
            poblacion_tomador: "",
            cod_postal_tomador: "",
            provincia_tomador: "",
            nacionalidad_tomador: "",
            fecha_nacimiento_tomador: "",
            sexo_tomador: "",
            profesion_tomador: "",
            idioma_tomador: "",
            estado_civil_tomador: "",
            tomador_hijos: "",
            pais_residencia_tomador: "",
            telefono_fijo_tomador: "",
            telefono_movil_tomador: "",
            email_tomador: "",
            nombre_asegurado:"",
            primer_apellido_asegurado: "",
            segundo_apellido_asegurado: "",
            nif_asegurado: "",
            domicilio_asegurado: "",
            domicilio_numero_asegurado: "",
            domicilio_piso_asegurado: "",
            poblacion_asegurado: "",
            cod_postal_asegurado: "",
            provincia_asegurado: "",
            nacionalidad_asegurado: "",
            fecha_nacimiento_asegurado: "",
            sexo_asegurado: "",
            profesion_asegurado: "",
            regimen_asegurado_opcion: "",
            idioma_asegurado: "",
            estado_civil_asegurado:"",
            asegurado_hijos:"",
            pais_residencia_asegurado: "",
            telefono_fijo_asegurado: "",
            telefono_movil_asegurado:"",
            email_asegurado: "",
            cod_iban: "",
            cod_entidad: "",
            cod_oficina: "",
            num_dc: "",
            num_cuenta: "",
            fp_mensual: "",
            beneficiarios_fallecimiento: "",
            fecha_poblacion:"",
            fecha_dia:"",
            fecha_mes_texto:"",
            fecha_anio_largo:"",
            fecha_anio_corto:"",                     
            nombre_completo_tomador: "",
            domicilio_completo_tomador: "",
            localidad_provincia_tomador: "",
            iban: "",
            fecha_completa_texto: "",
            localidad: "",
            apellidos_tomador: "",
            es_dni: null,
            privacidad: null,
            fecha_mes: "",
            callback_url: "",
            action: "SIGN_NOW",
        }
      }
  },
  created() {
      this.dataStored = JSON.parse(localStorage.getItem(this.code))

      this.packSelected = this.dataStored.packSelected
      this.initialData = this.dataStored.initialData
      this.insuredData = this.dataStored.insuredData
      this.policyholder = this.dataStored.policyholderData
      this.packCommercialOffers = this.dataStored.packCommercialOffers
      this.commercialOffer = this.dataStored.commercialOffer

      // this.packCommercialOfferDetail = this.dataStored.packCommercialOfferDetails
      this.publicResponsabilityForm = this.dataStored.publicResponsibilityForm

      if (this.dataStored.healthQuestionnaireData) {

        this.healthQuestionnaire = this.dataStored.healthQuestionnaireData;
      }
      
      const today = new Date();
      this.todaysDay = today.getDate()
      this.todaysMonth = today.getMonth() + 1
      this.todaysYear = today.getFullYear()

      this.todaysDate = this.numberTwoDigits(this.todaysDay) + '-' + this.numberTwoDigits(this.todaysMonth) + '-' + this.todaysYear;
      
  },
  methods: {
      numberTwoDigits(number) {
        return (number < 10 ? '0' : '') + number;
      },
      beneficiariesForm(value) {
       
        this.beneficiariesData = value;
        if (this.commercialOffer.type == "PAQUETES") {

            this.$http.get(process.env.VUE_APP_BROKER_API + '/comercial-capital/' + this.initialData.commercialCode)
            .then((response) => {
              this.packCommercialOfferCapital = response.data.packOffer.filter(x => x.name == this.packSelected)[0]
                
              this.fillForm();
                
            })
          // } else if (this.commercialOffer.type == "PRODUCTO" || this.commercialOffer.type == "LIBRE") {
        } else if (this.commercialOffer.type == "LIBRE") {

            this.offerCalculated = this.dataStored.offerCalculated
            let params = {
                name: "",
                coverages: []
            }
            
            params.name = this.commercialOffer.commercialOfferCode;
            this.offerCalculated.covers.forEach(element => {
                let cover = {
                    coverCode: "",
                    capital: 0,
                    productId: ""
                }
                cover.capital = parseInt(element.capital);
                cover.coverCode = element.coverCode;
                cover.productId = element.productId;

                params.coverages.push(cover);
            });

            this.$http.post(process.env.VUE_APP_BROKER_API + '/comercial-capital-pack', params)
            .then((response) => {
                this.packCommercialOfferCapital = response.data.packOffer[0]
            
                this.fillForm();
                
            })
        }

      },
      getPaymentMethod(){
           let paymentMethod = ""
           switch(this.commercialOffer.paymentMethod){
               case 1:
                   paymentMethod = "anual"
                break;

               case 2:
                paymentMethod = "semestral"
                break;

               case 3:
                paymentMethod = "cuatrimestral"
                break;

               case 4:
                paymentMethod = "trimestral"
                break;

               case 6:
                paymentMethod = "bimensual"
                break;

               case 12:
                paymentMethod = "mensual"
                break;
           }

           return paymentMethod
       },

    async fillForm() {
          try {
           
            const dateString = this.beneficiariesData.initDate;

            //Parse init data to from day-month-year to year-month-day to use newDate
            const changedDate = dateString.replace(/(..)-(..)-(....)/, '$3-$2-$1');

            var newDate = new Date(changedDate);
            let initDay = newDate.getDate()
            let initMonth = newDate.getMonth() + 1
            let initYear = newDate.getFullYear()

            this.initDataConverted = this.numberTwoDigits(initDay) + '-' + this.numberTwoDigits(initMonth) + '-' + initYear;
            
            const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Deciembre"
            ];
            
            //beneficiaries data  
            this.formToFill.fecha_efecto_global = this.initDataConverted
            this.formToFill.beneficiarios_fallecimiento =  this.beneficiariesData.beneficiaries
            this.formToFill.fecha_completa = this.todaysDate
            
            //PolicyHolderData
            //if policyHolder is the same person that insured
            if(this.insuredData.policyholderIsInsured) {
                 this.formToFill.nombre_tomador = this.insuredData.name
                    this.formToFill.primer_apellido_tomador =  this.insuredData.firstSurname
                    this.formToFill.segundo_apellido_tomador = this.insuredData.secondSurname
                    this.formToFill.nif_tomador =  this.insuredData.nif
                    this.formToFill.domicilio_tomador = this.insuredData.address
                    this.formToFill.domicilio_numero_tomador =   this.insuredData.addressNum
                    this.formToFill.tomador_hijos =   this.insuredData.children
                    this.formToFill.domicilio_piso_tomador =   this.insuredData.addressFloor
                    this.formToFill.poblacion_tomador =  this.insuredData.home
                    this.formToFill.cod_postal_tomador = this.insuredData.postalCode
                    this.formToFill.provincia_tomador =  this.insuredData.province
                    this.formToFill.nacionalidad_tomador =  this.insuredData.nationality
                    this.formToFill.fecha_nacimiento_tomador =  this.initialData.bornDate
                    this.formToFill.sexo_tomador =  this.insuredData.gender
                    this.formToFill.idioma_tomador=  this.insuredData.language
                    this.formToFill.estado_civil_tomador= this.insuredData.civilStatus
                    this.formToFill.profesion_tomador =  this.initialData.profession
                    this.formToFill.pais_residencia_tomador= this.insuredData.country
                    this.formToFill.telefono_fijo_tomador= this.insuredData.phone
                    this.formToFill.telefono_movil_tomador= this.insuredData.mobilePhone
                    this.formToFill.email_tomador= this.initialData.email
            } else {
                //if policyholder is diferent person that insured and is a physical person
                if (this.policyholder.policyholderType == "physical") {
    
                    this.formToFill.nombre_tomador = this.policyholder.name
                    this.formToFill.primer_apellido_tomador =  this.policyholder.firstSurname
                    this.formToFill.segundo_apellido_tomador = this.policyholder.secondSurname
                    this.formToFill.nif_tomador =  this.policyholder.nif
                    this.formToFill.domicilio_tomador = this.policyholder.address
                    this.formToFill.domicilio_numero_tomador =  this.policyholder.addressNum
                    this.formToFill.domicilio_piso_tomador =  this.policyholder.addressFloor
                    this.formToFill.poblacion_tomador =  this.policyholder.home
                    this.formToFill.cod_postal_tomador = this.policyholder.postalCode
                    this.formToFill.provincia_tomador =  this.policyholder.province
                    this.formToFill.nacionalidad_tomador =  this.policyholder.nationality
                    this.formToFill.tomador_hijos =   this.policyholder.children
                    this.formToFill.profesion_tomador =  this.policyholder.profession
                    this.formToFill.idioma_tomador=  this.policyholder.language
                    this.formToFill.fecha_nacimiento_tomador =  this.policyholder.bornDate
                    this.formToFill.sexo_tomador =  this.policyholder.gender
                    this.formToFill.pais_residencia_tomador= this.policyholder.country
                    this.formToFill.telefono_fijo_tomador= this.policyholder.phone
                    this.formToFill.telefono_movil_tomador= this.policyholder.mobilePhone
                    this.formToFill.email_tomador= this.policyholder.email
                    this.formToFill.estado_civil_tomador= this.policyholder.civilStatus

                //if policyholder is diferent person that insured and is a legal person
                } else if (this.policyholder.policyholderType == "legal") {

                    this.formToFill.nombre_tomador = this.policyholder.businessName
                    this.formToFill.nif_tomador =  this.policyholder.cif
                    this.formToFill.domicilio_tomador = this.policyholder.businessAddress
                    this.formToFill.domicilio_numero_tomador =  this.policyholder.businessAddressNum
                    this.formToFill.domicilio_piso_tomador =  this.policyholder.businessAddressFloor
                    this.formToFill.poblacion_tomador =  this.policyholder.businessHome
                    this.formToFill.cod_postal_tomador = this.policyholder.businessPostalCode
                    this.formToFill.provincia_tomador =  this.policyholder.businessProvince
                    this.formToFill.provincia_tomador =  this.policyholder.businessProvince
                    this.formToFill.nacionalidad_tomador =  this.policyholder.businessNationality
                    this.formToFill.pais_residencia_tomador= this.policyholder.businessCountry
                    this.formToFill.telefono_fijo_tomador= this.policyholder.businessPhone
                    this.formToFill.telefono_movil_tomador= this.policyholder.businessMobilePhone
                    this.formToFill.email_tomador= this.policyholder.businessEmail
                    
                }
            }

            //InsuredData
            this.formToFill.nombre_asegurado= this.insuredData.name
            this.formToFill.primer_apellido_asegurado =  this.insuredData.firstSurname
            this.formToFill.segundo_apellido_asegurado =  this.insuredData.secondSurname
            this.formToFill.nif_asegurado = this.insuredData.nif
            this.formToFill.domicilio_asegurado =  this.insuredData.address
            this.formToFill.domicilio_numero_asegurado = this.insuredData.addressNum
            this.formToFill.domicilio_piso_asegurado =  this.insuredData.addressFloor
            this.formToFill.poblacion_asegurado = this.insuredData.home
            this.formToFill.cod_postal_asegurado =  this.insuredData.postalCode
            this.formToFill.provincia_asegurado = this.insuredData.province
            this.formToFill.asegurado_hijos =   this.insuredData.children
            this.formToFill.nacionalidad_asegurado = this.insuredData.nationality
            this.formToFill.fecha_nacimiento_asegurado =  this.initialData.bornDate
            this.formToFill.sexo_asegurado = this.insuredData.gender
            this.formToFill.profesion_asegurado =  this.initialData.profession
            this.formToFill.idioma_asegurado = this.insuredData.language
            this.formToFill.estado_civil_asegurado =  this.insuredData.civilStatus
            this.formToFill.pais_residencia_asegurado = this.insuredData.country
            this.formToFill.telefono_fijo_asegurado =  this.insuredData.phone
            this.formToFill.telefono_movil_asegurado =  this.insuredData.mobilePhone
            this.formToFill.email_asegurado =  this.initialData.email

            //billingData
            this.formToFill.cod_iban =  ""
            this.formToFill.cod_entidad =  ""
            this.formToFill.cod_oficina = ""
            this.formToFill.num_dc =  ""
            this.formToFill.num_cuenta = this.beneficiariesData.iban
            this.formToFill.fp_mensual =  this.commercialOffer.paymentMethod
            
            this.formToFill.fecha_poblacion = this.insuredData.home
            this.formToFill.fecha_dia = this.todaysDay;
            this.formToFill.fecha_mes_texto = monthNames[this.todaysMonth - 1]
            this.formToFill.fecha_anio_largo = initYear
            this.formToFill.fecha_anio_corto = this.todaysYear.toString().slice(-2)
                          
             //SEPA DOCUMENT DATA  
            if (this.policyholder.policyholderType == "legal") {
              this.formToFill.nombre_completo_tomador = this.policyholder.businessName
              this.formToFill.domicilio_completo_tomador = this.policyholder.businessAddress + " " + this.policyholder.businessAddressNum  + " " + this.policyholder.businessAddressFloor
              this.formToFill.localidad_provincia_tomador =  this.policyholder.businessHome
              this.formToFill.fecha_poblacion = this.policyholder.businessHome
            } else {
              this.formToFill.nombre_completo_tomador = this.policyholder.name + " " + this.policyholder.firstSurname + " " + this.policyholder.secondSurname
              this.formToFill.domicilio_completo_tomador = this.policyholder.address
              this.formToFill.localidad_provincia_tomador =  this.policyholder.home
            }
            //----
            this.formToFill.iban = this.beneficiariesData.iban
            this.formToFill.fecha_completa_texto =  this.initDataConverted
            this.formToFill.localidad = this.policyholder.home

            this.formToFill.apellidos_tomador =  this.policyholder.firstSurname + " " + this.policyholder.secondSurname
            this.formToFill.es_dni =  1
            this.formToFill.privacidad = 1

            // this.formToFill.fecha_mes =  monthNames[initMonth - 1];
            // to look by index in monthNames July 07 -> 6 as index
            
            this.formToFill.fecha_mes =  this.numberTwoDigits(this.todaysMonth);

          if (this.initialData.regime == "ajena") {
          this.formToFill.regimen_asegurado_opcion = "A"
          } else {

          this.formToFill.regimen_asegurado_opcion = "P"
          }
            //information to signaturit
            this.formToFill.callback_url = this.commercialOffer.urlRedirect
            this.formToFill.action = "SIGN_NOW"

            this.formToFill['beneficiarios_axa_vida'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_axa_acc'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_surne'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_vida_antares'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_vida_gen'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_pm_it'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_axa_dep'] = this.beneficiariesData.beneficiaries;
            this.formToFill['beneficiarios_orf_surne'] = this.beneficiariesData.beneficiaries;

            //Public Responsability Form Data
              this.publicResponsabilityForm.forEach( element => {
                  this.formToFill[element.key] = element.value

                  if (element.subQuestions) {
                    element.subQuestions.forEach(subQuestion => {
                      this.formToFill[subQuestion.key] = subQuestion.value
                    })
                  }
              })
      
            //health Questionnaire Form Data
              if (this.dataStored.telesubscription == false ) {
                               
                this.healthQuestionnaire.forEach( element => {
                    this.formToFill[element.key] = element.value
                    if (element.subQuestions) {
                      element.subQuestions.forEach(subQuestion => {
                          if (subQuestion.subAnswers) {
                              subQuestion.subAnswers.forEach(subAnswer => {
                                  if(subAnswer.value != null) {
                                      this.formToFill[subAnswer.key] = subAnswer.value
                                  }
                              })
                          } else if (subQuestion.value != null){
                              this.formToFill[subQuestion.key] = subQuestion.value
                          }
                      })
                  }
                })
              }

             
            let products = []

            //capital and covers
            this.packCommercialOfferCapital.capitalOffer.forEach(cover => {
                
                if (cover.baremade) {
                  this.formToFill[cover.baremade] = 1
                }
                if (cover.coverType) {
                  this.formToFill[cover.coverType] = 1
                }
                
                this.formToFill[cover.productCover] = cover.capital
                this.formToFill[cover.productCoverCheck] = 1
                
                  // Get products used to associate the paymentMethod to each of them
                 let productId = cover.productCover.split('_')
                 if (products.includes(productId[0]) == false){
                   products.push(productId[0])

                  }
            })

            if(products != []) {
         
              products.forEach(id => {
                  let coverPayment = id + "_FPD" 
                  this.formToFill[coverPayment] = "Pago: " + this.getPaymentMethod()

                  coverPayment = id + "_FP" 
                  this.formToFill[coverPayment] = this.commercialOffer.paymentMethod
                })
            }

            // Parse data needed by ApiBroker to avoid it from doing unnecessary tasks - data already stored here 
            let productsIdData = []
            let packCommercialOfferData = {
              profession: this.initialData.profession,
              bornDate: this.initialData.age, 
              regime: "",
              paymentType: this.commercialOffer.paymentMethod,
              commercialOfferCode: this.code,
              covers: []
            }

            let filesIds = null
               
            if (this.commercialOffer.type == "PAQUETES" ) {
              
                this.commercialOffer.productsId.forEach(id => {
                  productsIdData.push(id)
                })
                
                packCommercialOfferData.regime = this.initialData.regime

                this.commercialOffer.coverPackages.filter(x => x.name == this.packSelected)[0].coverages.forEach(coverToAppend => {
                  packCommercialOfferData.covers.push(coverToAppend)
                })
                
              filesIds = this.commercialOffer.filesId

            } else  if (this.commercialOffer.type == "LIBRE") {
               
                this.dataStored.productsSelected.forEach(id => {
                  productsIdData.push(id)
                })

                packCommercialOfferData.regime = this.initialData.regime

                this.offerCalculated.covers.forEach(cover => {

                  let params = {
                    capital: cover.capital,
                    coverCode: cover.coverCode,
                    product: cover.productId,
                    productId: cover.productId,
                    period: cover.period,
                    // tarifa: ""
                  }
                  packCommercialOfferData.covers.push(params)
                })

                filesIds = this.dataStored.filesToSign
                
            // } else if (this.commercialOffer.type == "PRODUCTO") {

            //     productsIdData.push(this.commercialOffer.productSelect.productId)

            //     packCommercialOfferData.regime = this.initialData.regime

            //     this.packCommercialOffers.forEach(cover => {

            //       let params = {
            //         capital: cover.capital,
            //         coverCode: cover.coverCode,
            //         product: this.commercialOffer.productSelect.productId,
            //         productId: this.commercialOffer.productSelect.productId,
            //         period: cover.period,
            //         // tarifa: ""
            //       }
            //       packCommercialOfferData.covers.push(params)
            //     })

            //   filesIds = this.commercialOffer.filesId
            }

          let params = {
            fillData: this.formToFill,
            initialDataId: this.initialData.initialDataId,
            fileIds: filesIds,
            productsId: productsIdData,
            packCommercialOffer: packCommercialOfferData,

          }

          await this.$http.post(process.env.VUE_APP_BROKER_API + '/signaturit/' + this.initialData.commercialCode, params )
            .then((response) => {
              if(response.success != false) {

                localStorage.removeItem(this.code);
                window.location.href = response.data.resultUrl;
                // Changed as the window was blocked in IOS 
                // window.open(response.data.resultUrl, '_self');

                // Used when testing to see variables in process
                // this.$vs.loading.close()
                // window.open(response.data.resultUrl, '_blank');
              }
            })
              

          } catch (err) {
            this.$vs.loading.close()
            this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      }
  }
    
}
</script>

<style lang="scss">

</style>